import { createMemoryHistory, createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import RealtorsHomeView from '../views/Home/RealtorsHomeView.vue'
import TargetView from '../views/Home/Target/TargetView.vue'
import LoginUsersView from '../views/LoginUsers/LoginUsersView.vue'
import RegisterUsersView from '../views/LoginUsers/RegisterUsersView.vue'
import AdminView from '../views/Admin/AdminView.vue'
import SettingsView from '../views/Admin/SettingsView.vue'
import DashboardPanelView from '../views/Admin/DashboardPanelView.vue'
import SettingsPanelView from '../views/Admin/SettingsPanelView.vue'
import MessageView from '../views/Admin/MessageView.vue'
import ResidentialView from '../views/Admin/ResidentialView.vue'
import MortgagePaymentView from '../views/Admin/MortgagePaymentView.vue'
import GetLoanView from '../views/Admin/GetLoanView.vue'
import TotalCashMonthlyPaymentView from '../views/Admin/TotalCashMonthlyPaymentView.vue'
import TotalFinancialMonthlyPaymentView from '../views/Admin/TotalFinancialMonthlyPaymentView.vue'
import BudgetOldView from '../views/Admin/BudgetView.vue'
import FlipPropertyReadyView from '../views/Admin/FlipPropertyReadyView.vue'
import FlipAsIsView from '../views/Admin/FlipAsIsView.vue'
import PasiveFinancialView from '../views/Admin/PasiveFinancialView.vue'
import PasiveCashView from '../views/Admin/PasiveCashView.vue'
import ShortTermCashView from '../views/Admin/ShortTermCashView.vue'
import ShortTermFinancialView from '../views/Admin/ShortTermFinancialView.vue'
import ContactRealtorView from '../views/Contact/ContactRealtorView.vue'
import AdminContactsView from '../views/Admin/AdminContactsView.vue'
import ForeignViewVue from '@/views/Admin/ForeignView.vue'
import CompanyView from '../../src/views/VideoEmail/CompanyView.vue'
import InspectorView from '../../src/views/VideoEmail/InspectorView.vue'
import MloView from '../../src/views/VideoEmail/MloView.vue'
import RegisterUsersPaymentsView from '@/views/LoginUsers/RegisterUsersPaymentsView.vue'
import FaqsViewVue from '../views/Home/Target/FaqsView.vue'
import VistaVideoMloView from '../views/Home/VistaVideoMloView.vue'
import VistaVideoRealtorView from '../views/Home/VistaVideoRealtorView.vue'
import SupportMessagesView from '@/views/Admin/SupportMessagesView.vue'
import MLOOverviewView from '@/views/Home/MLOOverviewView.vue'
import RealtorsOverviewView from '@/views/Home/RealtorsOverviewView.vue'
import LandingMLO from '@/views/Home/LandingMLO.vue'
import LandinTitleCompany from '@/views/Home/LandingTitleCompany.vue'
import LandingInspector from '@/views/Home/LandingInspector.vue'
import LandingRealtors from '@/views/Home/LandingRealtors.vue'
import VideoRealtor from '@/views/Home/VideoRealtor.vue'
import AboutView from '@/views/AboutView.vue'
import TitleCompanyDashboard from '@/components/TitleCompanyDashboard.vue'
import Checkout from '@/views/LoginUsers/Checkout.vue'
import { vModelCheckbox } from 'vue'
import RealtorDashboard from '../views/Admin/RealtorDashboard.vue'
import RealtorScope from '../views/Admin/RealtorScope.vue'

//REALTOR VIEWS
import Budget from '@/views/Admin/Residential/Budget.vue'
import DTIRatio from '@/views/Admin/Residential/DTIRatio.vue'
import MortgagePayment from '@/views/Admin/Residential/MortgagePayment.vue'
import TotalFinancingMonthlyPayment from '@/views/Admin/Residential/TotalFinancingMonthlyPayment.vue'
import TotalCashMonthly from '@/views/Admin/Residential/TotalCashMonthly.vue'
import FlipPropertyReady from '@/views/Admin/Investment/FlipPropertyReady.vue'
import FlipAsIs from '@/views/Admin/Investment/FlipAsIs.vue'
import PasiveCash from '@/views/Admin/Investment/PasiveCash.vue'
import PasiveFinancial from '@/views/Admin/Investment/PasiveFinancial.vue'
import ShortTermFinancing from '@/views/Admin/Investment/ShortTermFinancing.vue'
import ShortTermCash from '@/views/Admin/Investment/ShortTermCash.vue'
import TypePayment from '@/views/LoginUsers/TypePayment.vue'


//MLO VIEWS
import Primary from '@/views/Admin/Tables/Primary.vue'
import Second from '@/views/Admin/Tables/Second.vue'
import Investment from '@/views/Admin/Tables/Investment.vue'
import SpecialProgram from '@/views/Admin/Tables/SpecialProgram.vue'
import Foreign from '@/views/Admin/Tables/Foreign.vue'

//TITLE COMPANY
import TitleCompanyTables from '@/components/admin/Tables/TitleCompanyTables.vue'
import CounReport from '@/views/Admin/adminReports/counReport.vue'
import MarketingCall from '@/views/Admin/adminReports/marketingCall.vue'
import DataReport from '@/views/Admin/adminReports/dataReport.vue'
import SubsystemCodeForm from '@/components/admin/Tables/subsystemCodeForm.vue'
import RealtorBenefits from '@/components/admin/Tables/Property/RealtorBenefits.vue'
import MarketingSend from '@/views/Admin/adminReports/marketingSend.vue'




const routes: Array<RouteRecordRaw> = [

    {
        path: '/',
        name: 'home',
        component: RealtorsHomeView,
    },

    {
        path: '/videoTitleCompany',
        name: 'companyview',
        component: CompanyView,
    },
    {
        path: '/videoInspector',
        name: 'inspectorview',
        component: InspectorView,
    },
    {
        path: '/videoMortgageLoanOriginator',
        name: 'mloview',
        component: MloView,
    },
    {
        path: '/target',
        name: 'target',
        component: TargetView
    },
    {
        path: '/vmlo',
        name: 'vmlo',
        component: VistaVideoMloView
    },
    {
        path: '/vrealtor',
        name: 'vrealtor',
        component: VistaVideoRealtorView
    },
    {
        path: '/overviewRealtor',
        name: 'overviewRealtor',
        component: RealtorsOverviewView
    },
    {
        path: '/overviewMlo',
        name: 'overviewMlo',
        component: MLOOverviewView
    },
    {
        path: '/faqs',
        name: 'faqs',
        component: FaqsViewVue
    },
    {
        path: '/realtor-tools-benefits',
        name: 'realtor-tools-benefits',
        component: RealtorBenefits
    },
    {
        path: '/loginusers',
        name: 'loginusersview',
        component: LoginUsersView
    },
    {
        path: '/register',
        name: 'registerusersview',
        component: RegisterUsersView,
        props: true
    },
    {
        path: '/register/realtorcode',
        name: 'realtorcode',
        component: SubsystemCodeForm,
        props: true
    },
    {
        path: '/register/typePayment',
        name: 'TypePayment',
        component: TypePayment,
        props: true
    },
    {
        path: '/register/payment',
        name: 'registeruserspaymentsview',
        component: RegisterUsersPaymentsView,
        props: true
    },
    {
        path: '/scope',
        name: 'realtorScope',
        component: RealtorScope,
        props: true
    },
    {
        path: '/admin/panel',
        name: 'adminview',
        component: AdminView,
        children: [
            {
                path: "",
                name: "admindashboardpanel",
                component: DashboardPanelView
            },
            {
                path: "count-report",
                name: "admincountpanel",
                component: CounReport
            },
            {
                path: "marketing-call",
                name: "adminmarketingpanel",
                component: MarketingCall
            },
            {
                path: "marketing-request",
                name: "marketingSend",
                component: MarketingSend
            },
            {
                path: "data-report",
                name: "admindatapanel",
                component: DataReport
            },
            {
                path: "contacts",
                name: "admincontactspanel",
                component: AdminContactsView
            },
            {
                path: "settings",
                name: "adminsettingspanel",
                component: SettingsPanelView
            },
            {
                path: "message",
                name: "realtormessages",
                component: MessageView
            },
            {
                path: "supportmessages",
                name: "supportmessages",
                component: SupportMessagesView
            },
            {
                path: "residential",
                name: "residential",
                component: ResidentialView
            },
            {
                path: "getloan",
                name: "getloan",
                component: GetLoanView
            },
            {
                path: "budget",
                name: "budget",
                component: Budget
            },
            {
                path: "budget-old",
                name: "budget-old",
                component: BudgetOldView
            },
            {
                path: "getloan",
                name: "getloan",
                component: DTIRatio
            },
            {
                path: "getloan-old",
                name: "getloan-old",
                component: GetLoanView
            },
            {
                path: "mortgage-payment",
                name: "mortgage-payment",
                component: MortgagePayment
            },
            {
                path: "mortgage-payment-old",
                name: "mortgage-payment-old",
                component: MortgagePaymentView
            },
            {
                path: "total-financial-monthly",
                name: "total-financial-monthly",
                component: TotalFinancingMonthlyPayment
            },
            {
                path: "total-financial-monthly-old",
                name: "total-financial-monthly-old",
                component: TotalFinancialMonthlyPaymentView
            },
            {
                path: "total-cash-monthly",
                name: "total-cash-monthly",
                component: TotalCashMonthly
            },
            {
                path: "total-cash-monthly-old",
                name: "total-cash-monthly-old",
                component: TotalCashMonthlyPaymentView
            },
            {
                path: "flip-property-ready",
                name: "flip-property-ready",
                component: FlipPropertyReady
            },
            {
                path: "flip-property-ready-old",
                name: "flip-property-ready-old",
                component: FlipPropertyReadyView
            },
            {
                path: "flip-as-is",
                name: "flip-as-is",
                component: FlipAsIs
            },
            {
                path: "flip-as-is-old",
                name: "flip-as-is-old",
                component: FlipAsIsView
            },
            {
                path: "pasive-financial",
                name: "pasive-financial",
                component: PasiveFinancial  
            },
            {
                path: "pasive-financial-old",
                name: "pasive-financial-old",
                component: PasiveFinancialView
            },
            {
                path: "pasive-cash",
                name: "pasive-cash",
                component: PasiveCash
            },
            {
                path: "pasive-cash-old",
                name: "pasive-cash-old",
                component: PasiveCashView
            },
            {
                path: "short-term-cash",
                name: "short-term-cash",
                component: ShortTermCash
            },
            {
                path: "short-term-cash-old",
                name: "short-term-cash-old",
                component: ShortTermCashView
            },
            {
                path: "short-term-financial",
                name: "short-term-financial",
                component: ShortTermFinancing
            },
            {
                path: "short-term-financial-old",
                name: "short-term-financial-old",
                component: ShortTermFinancialView
            },
            {
                path: "foreign",
                name: "foreign",
                component: ForeignViewVue
            },
            {
                path: "realtordashboard",
                name: "realtordashboard",
                component: RealtorDashboard
            },
            {
                path: "titleCompanyTables",
                name: "titleCompanyTables",
                component: TitleCompanyTables
            },
            {
                path: "tables",
                name: 'tables',
                children: [
                    {
                        path: "primary",
                        name: "table-primary",
                        component: Primary
                    },
                    {
                        path: "second",
                        name: "table-second",
                        component: Second
                    },
                    {
                        path: "investment",
                        name: "table-investment",
                        component: Investment
                    },
                    {
                        path: "special-program",
                        name: "table-special-program",
                        component: SpecialProgram
                    },
                    {
                        path: "foreign",
                        name: "table-foreign",
                        component: Foreign
                    },
                ]
            }
        ]
    },
    {
        path: "/contact/:role",
        name: "contactrelator",
        component: ContactRealtorView
    },
    {
        path: "/landing-mlo",
        name: "landingMLO",
        component: LandingMLO
    },
    {
        path: "/landing-title-company",
        name: "LandinTitleCompany",
        component: LandinTitleCompany
    },
    {
        path: "/landing-inspector",
        name: "LandingInspector",
        component: LandingInspector
    },
    {
        path: "/landing-realtors",
        name: "LandingRealtors",
        component: LandingRealtors
    },
    {
        path: "/realtor",
        name: "VideoRealtor",
        component: VideoRealtor
    },
    {
        path: "/about-us",
        name: "AboutView",
        component: AboutView
    },
   {
        path: "/checkout",
        name: "Checkout",
        component: Checkout
    },
    

]

const router = createRouter({
    //process.env.BASE_URL
    history: createWebHistory(),
    routes
})

export default router
